import { useDispatch } from 'react-redux';import { Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import Radio from '../../form/Radio';
import { showNotification } from '../../../redux/notification';
import LoaderIcon from '../../../assets/images/loader.svg';
import LicenseWarning from '../../../assets/images/warning-triangle-red-rounded.svg';

import './PrimaryLicense.scss';

const createLabel = (license) => (
	<div className='radio-group'>
		<div className='group-name'>{license.groupName}</div>
		<div className='licenses'>
			{license.licensesInGroup.join(', ')}
		</div>
	</div>
)

const createInvalidWarning = () => (
	<div className='license-warning'>
		<img src={LicenseWarning} alt="License Warning" />
		<div>Please note, all licenses in this practice area are currently rejected or failed.</div>
	</div>
)

const sortLicenses = (licenses) =>
	Object.entries(
		Object.groupBy((licenses ?? []), l => l.license_group)
	)
	// eslint-disable-next-line camelcase
	.map(([license_group, licensesInGroup]) => ({
		groupId: String(licensesInGroup[0].license_group_id),
		// eslint-disable-next-line camelcase
		groupName: license_group,
		licensesInGroup: [...new Set(licensesInGroup.map(l => l.name))].sort((a, b) => a.localeCompare(b)),
		primaryLicenseGroup: String(licensesInGroup[0].primary_license_group_id),
		areAllLicensesInvalid: (licensesInGroup.filter(l => l.status === 'failed' || l.status === 'rejected')).length === licensesInGroup.length
	}))
	.sort((a, b) => (a.groupName || '').localeCompare(b.groupName || ''));


const mapLicensesToOptions = (licenses) =>
	sortLicenses(licenses)?.map(license => ({
		id: license.groupId,
		value: license.groupId,
		label: createLabel(license),
		footer: license.areAllLicensesInvalid ? createInvalidWarning() : null,
		originalGroup: license.primaryLicenseGroup
	}));

const PrimaryLicenseModal = ({caregiverId, managementCompanyId, onClose, credentialByTypeQuery, setPrimaryLicenseGroupMutation}) => {
	const dispatch = useDispatch();

	const [licenses, setLicenses] = useState([]);
	const [selectedGroup, setSelectedGroup] = useState(null);

	const { data: credentialByType, error: credentialByTypeError } = credentialByTypeQuery(
		{ caregiverId, managementCompanyId, credType: 'PROFESSIONAL_LICENSE', source: 'table' },
		{
			refetchOnMountOrArgChange: true
		}
	);

	const [ setPrimaryLicenseGroup, {isLoading} ] = setPrimaryLicenseGroupMutation();

	useEffect(() => {
		if(credentialByTypeError){
			setLicenses([]);
		}
	}, [credentialByTypeError]);

	useEffect(() => {
		setLicenses(mapLicensesToOptions(credentialByType?.data));
	}, [credentialByType]);

	useEffect(() => {
		setSelectedGroup(licenses[0]?.originalGroup);
	}, [licenses]);

	const onSavePrimaryLicenseGroup = async () => {
		if (isLoading) {
			return;
		}

		try {
			await setPrimaryLicenseGroup({
				caregiverId,
				groupId: selectedGroup,
				managementCompanyId
			}).unwrap();
			onClose();
		} catch (error) {
			dispatch(showNotification('error', 'There was an issue setting the primary license group'));
		}
	}

return (
	<Modal
	show
	centered
	backdrop="static"
	className='primary-license-modal'
	onHide={onClose}
	keyboard={false}
	>
		<Modal.Header closeButton>
			<Modal.Title>
				Select Primary Practice Area
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<div className='modal-body-container'>
				<div className="info-container">
					<span className='info-text'>This caregiver is eligible to work in multiple practice areas.</span>
					<span className='select-text'>Select their primary practice area</span>
				</div>
				<div className='clickable-radio'>
					<Radio
						options={licenses ?? []}
						name="primary-licenses"
						selectedOption={selectedGroup}
						handleChange={(e) => setSelectedGroup(e)}
					/>
				</div>
			</div>
		</Modal.Body>

		<Modal.Footer>
			<div className="buttons">
				<button type="button" className="btn-purple__text" onClick={onClose}>
					Cancel
				</button>
				<button
					type="button"
					className="btn-purple"
					onClick={onSavePrimaryLicenseGroup}
					disabled={isLoading}
				>
					{isLoading ? (
						<>
							<img aria-hidden src={LoaderIcon} alt="loader" className="button-loading-spinner" /> Updating...
						</>
					) : (
						<>
							Confirm
						</>
					)}
				</button>
			</div>
		</Modal.Footer>
	</Modal>
)
}

export default PrimaryLicenseModal;
